/**
 * electronAPI.js — API bridge (web-only)
 * Sets window.api to the Supabase-backed DB layer.
 */
import supabaseDB from './supabaseDB';

window.api = supabaseDB;

export const api = supabaseDB;
